import { render, staticRenderFns } from "./NumberMaskLabel.vue?vue&type=template&id=c4d28174&scoped=true"
import script from "./NumberMaskLabel.vue?vue&type=script&lang=js"
export * from "./NumberMaskLabel.vue?vue&type=script&lang=js"
import style0 from "./NumberMaskLabel.vue?vue&type=style&index=0&id=c4d28174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d28174",
  null
  
)

export default component.exports